import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'mac-input-text',
  templateUrl: './input-text.component.html',
  standalone: false,
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent implements OnInit {
  @Input() type: 'text' | 'email' | 'password' = 'text';
  @Input() name?: string;
  @Input() placeholder?: string;
  @Input() control: FormControl<string | null>;
  @Input() disabled: boolean = false;
  @Input() icon?: string;
  @Input() suffix?: string | TemplateRef<void>;
  @Input() addSuffixContent?: boolean = false;
  @Input() prefix?: string;
  @Input() addOnAfter?: string | TemplateRef<void>;

  @ViewChild('inputComponent') inputComponent!: ElementRef;

  ngOnInit(): void {
    if (!this.control && this.disabled) {
      this.control = new FormControl<string>('');
      this.control.disable();
    }
  }

  focus() {
    this.inputComponent.nativeElement.focus();
  }
}
